module.exports = __webpack_public_path__ + "media/images/flextab_logo-c3e10778341a94cf9dbc1fd5d75c55fe.svg";